import React from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white shadow-md mt-8">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-600 text-center sm:text-left">
            Наступны прыпынак — прырода.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-sm">
            <div className="flex items-center gap-2 text-gray-600">
              <Mail size={18} className="text-primary" />
              <a 
                href="mailto:mamanovichks@gmail.com"
                className="hover:text-primary transition-colors"
              >
                mamanovichks@gmail.com
              </a>
            </div>
            <Link 
              to="/"
              className="text-gray-600 hover:text-primary transition-colors"
            >
              Аб сэрвісе
            </Link>
            <Link 
              to="/privacy-policy"
              className="text-gray-600 hover:text-primary transition-colors"
            >
              Палітыка прыватнасці
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};